import { Flex, Input, Span, Button, Label, Grid } from '@fareye/ui'
import { getValueFromNestedKey } from '@fareye/utils'
import React from 'react'
import { formatters } from '../../../config/constants'
import { ColFullHeight } from '../../../style/styled'
import { IColumnConfig } from '../../../utility/types'
import RemoveDevicebutton from './RemoveDevicebutton'

function generateColumnObject(column: IColumnConfig, propsConfig: any) {
  //TODO: Add Tracking column
  let { label, key, formatter, link = '' } = column

  const { t, setSelectedDevice, setDevices } = propsConfig
  switch (key) {
    case 'action':
      return {
        Header: <Label color="black">{t(label)}</Label>,
        id: key,
        width: 60,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight data-testid="referenceNo|slug">
            <Grid gridTemplateColumns="repeat(3,1fr)" gridGap={'5px'}>
              <Button
                onClick={() =>
                  setSelectedDevice({
                    data: original,
                    openHistoryModal: false,
                    openEditModal: true
                  })
                }
                variant="s primary"
              >
                Edit
              </Button>
              <Button
                onClick={() =>
                  setSelectedDevice({
                    data: original,
                    openHistoryModal: true,
                    openEditModal: false
                  })
                }
                variant="s secondary"
              >
                history
              </Button>
              {/* <RemoveDevicebutton
                device={original}
                setSelectedDevice={setSelectedDevice}
                setDevices={setDevices}
              /> */}
            </Grid>
          </ColFullHeight>
        )
      }

    default:
      return {
        Header: <Label color="black">{t(label)}</Label>,
        id: key,
        width: 50,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => {
          let value = getValueFromNestedKey(original, key)
          return (
            <ColFullHeight data-testid={key}>
              <Span fontSize={14} variant="ellipsis">
                {formatter && formatters[formatter]
                  ? formatters[formatter](value) || '-'
                  : value ?? '-'}
              </Span>
            </ColFullHeight>
          )
        }
      }
  }
}
export function getTableColumns(
  reqdColumns: IColumnConfig[],
  propsConfig?: any
) {
  const COLUMNS = reqdColumns.map(ele => generateColumnObject(ele, propsConfig))

  //const result = COLUMNS.filter(column => reqdColumns.includes(column.id))
  return COLUMNS
}
